
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { OrgaoDoJudiciario } from '@app/models/orgao-do-judiciario.model';

@Injectable()
export class OrgaoDoJudiciarioService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(orgaosDoJudiciario: OrgaoDoJudiciario): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/orgaosDoJudiciario', orgaosDoJudiciario).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/orgaosDoJudiciario/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/orgaosDoJudiciario/${id}`);
  }

  obterLista(nome: string, pagina: number): Observable<any> {
    nome = encodeURIComponent(nome);
    return this.http
      .get<any>(this.URL_API + `configuracoes/orgaosDoJudiciario/lista/?nome=${nome}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + "configuracoes/orgaosDoJudiciario")
  //     .map((res: Response) => res.json());
  // }

}
